export const PageRoute = {
  Index: "/",
  Sleep: "/sleep",
  FoodList: "/food-list",
  Account: "/account",
  FoodDetail: "/foods/:id",
};
